import script from "./SavedFiltersWarningIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./SavedFiltersWarningIcon.vue?vue&type=script&setup=true&lang=js"

import "./SavedFiltersWarningIcon.vue?vue&type=style&index=0&id=92db9f0e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92db9f0e"]])

export default __exports__